<script setup lang="ts">
import type { PdpEcommerceBlockFitFinderProps } from '@design-system/components/Pdp/EcommerceBlock/PdpEcommerceBlockFitFinder.props'
import type {
  Category,
  SizeDetails,
} from '@design-system/components/Pdp/PdpFitFinder.props'
import { SIDEBAR_IDS } from '@design-system/data/sidebarIds'

const props = defineProps<PdpEcommerceBlockFitFinderProps>()
const emit = defineEmits<{
  onFitFinderClick: []
}>()

const { openDialog, closeDialog } = useDialog(
  SIDEBAR_IDS.pdpEcommerceBlockFitFinder
)

const {
  sizeGridData: sizeData,
  productCategory,
  countries,
} = await useFitFinder(props.sizeCodeId ?? '')

const { emitSizebayProductViewEvent } = useSizebayEvents()
const route = useRoute()

const noSizeBay = route.query.noSizeBay === 'true'
onMounted(() => {
  if (!props.hideSidebar && !noSizeBay) {
    //no re-trigger in complete the look
    emitSizebayProductViewEvent(props.productId, props.productTitle)
  }
})

const handlePrimaryClick = () => {
  closeDialog()
}

const handleFitFinderClick = () => {
  setTimeout(() => {
    const sizeBayModalOk = document
      .querySelector('html')
      ?.classList.contains('vfr-modal-active')
    if (!sizeBayModalOk) {
      openDialog()
    }
  }, 300)
  emit('onFitFinderClick')
}
</script>
<template>
  <AsideButton
    class="border-t-0"
    :data-testid="!noSizeBay ? 'fit-finder' : ''"
    :aria-label="$ts('accessibility.openFitFinder')"
    @click="handleFitFinderClick"
  >
    <p class="text-medium-6">
      {{ $ts('pdp.fitFinder.label') }}
    </p>
  </AsideButton>

  <OrganismsSidebarSlide
    v-if="!hideSidebar"
    :id="SIDEBAR_IDS.pdpEcommerceBlockFitFinder"
    :header-props="{
      titleText: $ts('pdp.fitFinder.label'),
    }"
    @primary-click="handlePrimaryClick"
  >
    <template #body>
      <PdpFitFinder
        :category="productCategory as unknown as Category"
        :countries="countries"
        :sizes-details="sizeData as unknown as SizeDetails[]"
        :side-slide-description="props.sideSlideDescription"
      />
    </template>
  </OrganismsSidebarSlide>
</template>
